export const SETTINGS_SECTIONS = [
  { id: 'connections', label: 'Connections' },
  { id: 'keys', label: 'API keys' },
  { id: 'subscriptions', label: 'Subscriptions' },
  { id: 'storage', label: 'Storage' },
  { id: 'node', label: 'Local Node' },
  { id: 'data', label: 'Data and export' },
  { id: 'account', label: 'Account' },
  { id: 'legal', label: 'Legal' },
] as const;

export type SettingsSection = (typeof SETTINGS_SECTIONS)[number]['id'];

export function isSettingsSection(value: string | null | undefined): value is SettingsSection {
  return SETTINGS_SECTIONS.some((section) => section.id === value);
}

export function settingsSectionFromSearch(search: string): SettingsSection | null {
  const value = new URLSearchParams(search).get('settings');
  return isSettingsSection(value) ? value : null;
}
